module.exports = __webpack_public_path__ + "static/media/instapage3.3e8792ab.png";